import { render, staticRenderFns } from "./resultat-ge.html?vue&type=template&id=51228e7d&scoped=true&external"
import script from "./resultat-ge.js?vue&type=script&lang=js&external"
export * from "./resultat-ge.js?vue&type=script&lang=js&external"
import style0 from "./resultat-ge.scss?vue&type=style&index=0&id=51228e7d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51228e7d",
  null
  
)

export default component.exports